import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, inject } from '@angular/core';
import { ButtonComponent } from '@kinomap-dev/ng-ui-lib/buttons';
import { FormsModule } from '@angular/forms';
import { EmailRequiredModalData } from 'app/shared/models/modal.models';
import { ModalContainerComponent } from '../modal-container/modal-container.component';

@Component({
  selector: 'app-email-required-modal',
  template: `
    <app-modal-container>
      <h1>Entrez un email</h1>
      <p>Entrez un email valide sur lequel recesoir l'export de ce leaderboard</p>
      <input type="email" name="email" id="email" [(ngModel)]="email" />
      <kin-btn (onClick)="onConfirm()" [disabled]="!isEmailValid(email)">Valider</kin-btn>
      <kin-btn (onClick)="onCancel()">Annuler</kin-btn>
    </app-modal-container>
  `,
  styleUrl: './email-required-modal.component.scss',
  imports: [ButtonComponent, FormsModule, ModalContainerComponent],
})
export class EmailRequiredModalComponent {
  private dialogRef: DialogRef = inject(DialogRef);
  public data: EmailRequiredModalData = inject(DIALOG_DATA);
  email: string = '';

  isEmailValid(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  onConfirm(): void {
    if (this.isEmailValid(this.email)) {
      if (this.data?.onConfirm) this.data.onConfirm(this.email);
    }
    this.dialogRef.close();
  }

  onCancel(): void {
    if (this.data?.onCancel) {
      this.data.onCancel();
    }
    this.dialogRef.close();
  }
}
